import React from 'react';
import TopHeader from './TopHeader';
import NewsMarquee from './NewsMarquee';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import BannerImage from './ui/BannerImage';
import BackToTop from './ui/BackToTop';

export default function Layout({ children, bannerTitle }) {
  return (
    <>
      <TopHeader />
      <NewsMarquee />
      <Header />
      <Navbar />
      {bannerTitle && <BannerImage title={bannerTitle} />}
      <main>{children}</main>
      <Footer />
      <BackToTop />
    </>
  );
}
